import React from "react";
import ReactDOM from "react-dom";
import paypal from "paypal-checkout";

import { API_URL } from "../constants/constants";
import { useAuth0 } from "../hooks/react-auth0-spa";
import axios from "axios";

const PaypalCheckoutButton = ({ recarga, order }) => {
  const { user, getTokenSilently } = useAuth0();
  const paypalConf = {
    currency: "MXN",
    env: "production", //sandbox production
    client: {
      sandbox:
        "AcSECOEXuzDTnkaTOBLiJsdtE-zMZIcwdjxqSLInzbFubBB3jjL3bm_nj2dGPPESuYn1DIoVYegr1S2m",
      production:
        "AfHHTRY_G67KZvP5p6rl49W5VvI2wj_Ez0dDs800IP4FwvPOoHfW3ojXh1TrlSQkwKszeSKDgLpnt9jJ", //'AfHHTRY_G67KZvP5p6rl49W5VvI2wj_Ez0dDs800IP4FwvPOoHfW3ojXh1TrlSQkwKszeSKDgLpnt9jJ',
    },
    style: {
      label: "paypal",
      size: "responsive", // small | medium | large | responsive
      shape: "pill", // pill | rect
      color: "black", // gold | blue | silver | black
    },
  };

  const PayPalButton = paypal.Button.driver("react", { React, ReactDOM });

  const payment = (data, actions) => {
    const payment = {
      transactions: [
        {
          amount: {
            total: order.total,
            currency: paypalConf.currency,
          },
          description: "Recarga drEnvio",
          custom: order.customer || "",
          item_list: {
            items: order.items,
          },
        },
      ],
      note_to_payer: "Contáctanos para cualquier aclaración sobre tu compra.",
    };
    return actions.payment.create({
      payment,
    });
  };

  const onAuthorize = (data, actions) => {
    return actions.payment
      .execute()
      .then(async (response) => {
        // console.log(response);
        //TODO: Aqui va el envio al servidor
        try {
          const t = await getTokenSilently();
          await axios.post(
            API_URL + `/paypal/${user.sub}`,
            { response, recarga },
            {
              headers: {
                Authorization: `Bearer ${t}`,
                // "Access-Control-Allow-Origin": "*"
              },
            }
          );
          // console.log(r);
        } catch (e) {
          console.log(e);
        }
        alert(`El Pago fue procesado correctamente, recargue la pagina `);
        // setPayed(!payed)
      })
      .catch((error) => {
        console.log(error);
        alert("Ocurrió un error al procesar el pago con Paypal");
      });
  };

  const onError = (error) => {
    alert("El pago con PayPal no fue realizado, vuelva a intentarlo.");
  };

  const onCancel = (data, actions) => {
    alert("Usted ha cancelado el procesa de recarga con PayPal");
  };

  return (
    <PayPalButton
      env={paypalConf.env}
      client={paypalConf.client}
      payment={(data, actions) => payment(data, actions)}
      onAuthorize={(data, actions) => onAuthorize(data, actions)}
      onCancel={(data, actions) => onCancel(data, actions)}
      onError={(error) => onError(error)}
      style={paypalConf.style}
      commit
      locale="es_MX"
    />
  );
};

export default PaypalCheckoutButton;
//AcSECOEXuzDTnkaTOBLiJsdtE-zMZIcwdjxqSLInzbFubBB3jjL3bm_nj2dGPPESuYn1DIoVYegr1S2m
